import { RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const DELIVERIES_ROUTE_PROVIDERS = [
  {
    provide: APP_INITIALIZER,
    useFactory: configureRoutes,
    deps: [RoutesService],
    multi: true,
  },
];

function configureRoutes(routesService: RoutesService) {
  return () => {};
}
